import React, { useContext, useEffect, useState } from 'react';
import validator from 'validator'
import { TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { usePaystackPayment } from 'react-paystack';
import AlertPOP from '../../routes/AlertPOP';
import axios from 'axios';
import baseUrl from '../../BaseURL';
import nigeriaStates from './nigeriaStates';
import kadunaLocalGovernments from './kadunaLocalGovernments ';
import { ContextData } from '../../context/Context';
import Loader from '../../routes/Loader';
import SoundAlert from '../../routes/SoundAlert';


const useStyles = makeStyles((theme) => ({

  form: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    margin: 'auto',
    padding: theme.spacing(2),
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
  selectField: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));




function RegisterForm(props){


  const classes = useStyles()
  
  const {setUpdateAmount,UpdateAmount} = useContext(ContextData)
  const [message,setmessage] = useState("")
  const [open, setOpen] = useState(false);
  const [transition, setTransition] = useState(undefined);
  const [proceedForm, setproceedForm] = useState(true);
  const [OpenLoader,setOpenLoader] = useState(false)


  const [formData, setFormData] = useState({
    fname: '',
    md_name: '',
    lname: '',
    email: '',
    mobileNumber: '',
    gender: '',
    marital_status: '',
    d_o_b: '',
    resdential_type: '',
    state_of_origin: 'Kaduna',
    local_gov: '',
    pswrd: '',
    rpt_pswrd:'',
    degree_type:'',
    applicationtype:"",
    loanCategory: ""
  });
 

  
     const handleInputChange = (e) => {
       
       const { name, value } = e.target;
       setFormData((prevData) => ({ ...prevData, [name]: value }));
       
      }


     // Handle the alert transition and function
     const handleClick = (Transition) => {
      setTransition(() => "TransitionLeft")
       setOpen(true);
     };
     // Handle the close alert box 
     const handleClose = () => {
       setOpen(false);
     };

 
      // Handle data to server if succeed
 const handleSubmit = (e) => {
    
        e.preventDefault()
 
        /*  if(formData.md_name.trim() === "") {
            setFormData(prev =>({...prev,md_name :"N/A"}))
         } */

    if (Object.values(formData).every((value) => value.trim() === '' )) {
               // Call alert box function
          SoundAlert("error")
          handleClick("left")
          setmessage('Please fill in all required fields.');
          return
      }

      if (Object.values(formData).every((value) => value.trim() === 'Select')) {

        SoundAlert("error")  
        // Call alert box function
        handleClick("left")

        setmessage("Select Qualification");
        return
    }

    if(!validator.isEmail(formData.email)){
        SoundAlert("error")
      handleClick("left")

      setmessage("Email address is not a valid");
      return
    }

    if(!validator.isNumeric(formData.mobileNumber)){
        SoundAlert("error")
      handleClick("left")
      setmessage("Mobile Number is not a valid");
      return
    }


    if(formData.pswrd !== formData.rpt_pswrd){
          SoundAlert("error")
      handleClick("left")
      setmessage("Passwords is not match");
      return   
    }

     //  console.log(formData)

              // loader
              setOpenLoader(true)

        axios.post(`${baseUrl}/pub/signup`,formData)
        .catch(err => { 
          console.log(err.message) 
              // loader
              setOpenLoader(false)
        })
        .then((res) =>{  
           

                   if(res.data.status){
                    SoundAlert("success")
                     handleClick("left")
                     setmessage(res.data.textStatus);   
                        // loader
                     setOpenLoader(false)
                     
                     props.setchangeform("home")
                     props.setISAccount(true)

                   }

                   if(!res.data.status){
                    SoundAlert("error")
                    handleClick("left")
                    setmessage(res.data.textStatus);   
                        // loader
                    setOpenLoader(false)

                    
                  }



        })



  }




 const proceedFormFunc = ()=>{

  setproceedForm(false)
  
 }


  // Handle resdential function
  const handleResidentialTypeChange = (e) => {

    const selectedResidentialType = e.target.value

    setFormData((prevData) => ({
      ...prevData,
      resdential_type: selectedResidentialType,
      state_of_origin: selectedResidentialType === 'indigene' ? 'Kaduna' : 'Select State'
    }))

  }

  const   handldegree_typeTypeChange = (e) => {

    const degree_type = e.target.value

    setFormData((prevData) => ({
      ...prevData,
      degree_type: degree_type
    }))

  }







  return (
    <form className={`${classes.form}clnt-register-form clnt-register-form-con h-96 flex flex-col pb-16 `} style={{width:"25rem"}} onSubmit={handleSubmit}>

       <AlertPOP
       Open={open}
       handleClose={handleClose}
       transition={transition}
       message={message}
      />

       <Loader
       OpenLoader={OpenLoader}
      />

      <div className='flex flex-col innerform-inputs-con'>

         <FormControl className={classes.selectField}>
        <InputLabel> <span className='text-blue-900 font-bold mb-2'>Application Type </span></InputLabel>
        <Select
          name="applicationtype"
          value={formData.applicationtype}
          onChange={handleInputChange}
          required
          
        >
          <MenuItem value="Select">Select</MenuItem>
         <MenuItem value="scholarship">Scholarship</MenuItem>  
          <MenuItem value="loan">Tertiary Education Loans</MenuItem>
        </Select>
      </FormControl> 
      

             

     {
  formData.applicationtype === "scholarship" && (  
    <div className='flex flex-col'>
      <span className='text-blue-900 mb-2'>
        By selecting <strong>Scholarship</strong>, you are applying for a scholarship. 
        You will be required to provide all necessary information in the scholarship 
        application form. You can switch to the loan application if you wish, 
        but note that you can only apply for one at a time, unless the awarding 
        and benefiting period has finished.
      </span>
    </div>
  )
}

{
  formData.applicationtype === "loan" && (  
    <div className='flex flex-col'> 
      <span className='text-blue-900  mb-2'>
        By selecting <strong>Tertiary Education Loans</strong>, you are applying for a loan. 
        You will be required to provide all necessary details in the loan 
        application form. You can switch to the scholarship application if 
        you prefer.
      </span>
    </div>
  )
}


  

{/*  */}







{/* Universal Note */}
 {/* <div className='flex flex-col mt-4 mb-5'>
  <span className='text-gray-700 italic'>
    Note: You can only have one active application at a time. 
    Once the awarding and benefiting period of your current application is completed, 
    you may apply for the other option.
  </span>
</div>  */}






  {
       formData.applicationtype === "loan"  && 
       <FormControl className={classes.selectField}>
        <InputLabel> <span className='text-blue-900 font-bold mb-2'>Loan Category </span></InputLabel>
        <Select
          name="loanCategory"
          value={formData.loanCategory}
          onChange={handleInputChange}
          required
          
        >
          <MenuItem value="Select">Select</MenuItem>
         <MenuItem value="thirdparty">Third Party Loan</MenuItem>
          <MenuItem value="studentloan">Student Loan</MenuItem>
        </Select>
      </FormControl>
    }


      <TextField
        label="First Name"
        name="fname"
        value={formData.fname}
        onChange={handleInputChange}
        required
        className={classes.inputField}
        disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
      />
       <TextField
        label="Middle Name"
        name="md_name"
        value={formData.md_name}
        onChange={handleInputChange}
        className={classes.inputField}
        disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
      />
      <TextField
        label="Last Name"
        name="lname"
        value={formData.lname}
        onChange={handleInputChange}
        required
        className={classes.inputField}
        disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
      />
      <TextField
        label="Email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        required
        className={classes.inputField}
        disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
      />
      <TextField
        label="Valid Mobile Number"
        name="mobileNumber"
        value={formData.mobileNumber}
        onChange={handleInputChange}
        required
        type="tel"
        inputProps={{ maxLength: 11, minLength: 11, pattern: "[0-9]{11}" }}
        className={classes.inputField}
        disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
      />

     <FormControl className={classes.selectField}>
        <InputLabel>Residential Type</InputLabel>
        <Select
          name="resdential_type"
          value={formData.resdential_type}
          onChange={handleResidentialTypeChange}
          required
          disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="indigene">Indigene</MenuItem>
          <MenuItem value="resident">Resident</MenuItem>
        </Select>
      </FormControl>

    

      <FormControl className={classes.selectField}>
        <InputLabel>State of Origin</InputLabel>
        <Select
          name="state_of_origin"
          value={formData.state_of_origin}
          onChange={handleInputChange}
          disabled={formData.resdential_type === 'indigene' ? true : formData.applicationtype === "" || formData.applicationtype === "Select"}
          required
        
        >
          {
            nigeriaStates.map(list=>(<MenuItem value={list}>{list}</MenuItem>))
          }
        </Select>
      </FormControl>


      <FormControl className={classes.selectField}>
        <InputLabel>Local Government Of Residence</InputLabel>
        <Select
          name="local_gov"
          value={formData.local_gov}
          onChange={handleInputChange}
          required
          disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        >
          {
            kadunaLocalGovernments.map(list=>(<MenuItem value={list}>{list}</MenuItem>))
          }
        </Select>
      </FormControl>

      <FormControl className={classes.selectField}>
        <InputLabel>Gender</InputLabel>
        <Select
          name="gender"
          value={formData.gender}
          onChange={handleInputChange}
          required
          disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="male">Male</MenuItem>
          <MenuItem value="female">Female</MenuItem>
        </Select>
      </FormControl>

      <FormControl className={classes.selectField}>
        <InputLabel>Marital Status</InputLabel>
        <Select
          name="marital_status"
          value={formData.marital_status}
          onChange={handleInputChange}
          required
          disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="single">Single</MenuItem>
          <MenuItem value="married">Married</MenuItem>
          <MenuItem value="divorced">Divorced</MenuItem>
          <MenuItem value="widowed">Widowed</MenuItem>
        </Select>
      </FormControl>


      <span>Date OF Birth (dd/mm/yyyy)</span>
      <TextField
        label=""
        name="d_o_b"
        value={formData.d_o_b}
        onChange={handleInputChange}
        required
        className={classes.inputField}
        type='date'
        inputProps={{
          max: (() => { const d = new Date(); d.setFullYear(d.getFullYear() - 16); return d.toISOString().split('T')[0]; })(),
        }}
        disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
      />



      </div>


      <div className='flex flex-col'>

      <FormControl className={classes.selectField}>
        <InputLabel>Qualification Type</InputLabel>
        <Select
          name="degree_type"
          value={formData.degree_type}
          onChange={handldegree_typeTypeChange}
          required
            disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        >
          <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="undergraduate">Undergraduate</MenuItem>
          <MenuItem value="postgraduate">Postgraduate</MenuItem>
        </Select>
      </FormControl>
          
        <TextField
        label="Password"
        name="pswrd"
        value={formData.pswrd}
        onChange={handleInputChange}
        required
        className={classes.inputField}
        type='password'
          disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        />

        <TextField
        label="Repeat Password"
        name="rpt_pswrd"
        value={formData.rpt_pswrd}
        onChange={handleInputChange}
        required
        className={classes.inputField}
        type='password'
          disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
        />

      </div>

      
    
      <Button
       type="submit"  
       variant="contained" 
       color="primary" 
       className={classes.button}
         disabled={formData.applicationtype === "" || formData.applicationtype === "Select"}
       >
        Sign Up
      </Button>
      
      <br/>

    </form>
  );
};

export default RegisterForm;